import { useState } from "react";
import "./MenuSlider.scss";

const MenuSlider = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="main-side-menu">
      <div className="menu-icon" onClick={toggleMenu}>
        ☰ {/* Ícone de menu (pode ser um ícone de sua escolha) */}
      </div>
      <nav className={`side-menu ${isOpen ? "open" : ""}`}>
        <button className="close-btn" onClick={toggleMenu}>
          &times;
        </button>

        <ul>
          <li>
            <a href="#aboutUs" onClick={toggleMenu}>
              Sobre
            </a>
          </li>
          <li>
            <a href="#services" onClick={toggleMenu}>
              Serviços
            </a>
          </li>
          <li>
            <a href="#contact" onClick={toggleMenu}>
              Contato
            </a>
          </li>
        </ul>
      </nav>
      {isOpen && <div className="overlay" onClick={toggleMenu}></div>}
    </div>
  );
};

export default MenuSlider;
